import { AbstractPmsApiService } from "./abstract.service";
import { InternalMessage } from "../models";

/**
 * @class InternalMessagePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<InternalMessage>}
 */
export class InternalMessagePmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/internal-message(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {InternalMessage}
     * @protected
     */
    newModel(attributes, ...params) {

        return new InternalMessage(attributes);
    }

    /**
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<InternalMessage>>}
     */
    get(params = {}) {

        const url = this.url();
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: false
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {InternalMessage} message
     * @returns {Promise.<InternalMessage>}
     */
    create(message) {

        const url = this.url();

        return this.http
            .post(url, message, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {InternalMessage} message
     * @returns {Promise.<InternalMessage>}
     */
    update(message) {

        const url = this.url({id: message.id});

        return this.http
            .put(url, message, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {integer} messageId
     * @returns {Promise.<InternalMessage>}
     */
    show(messageId) {

        const url = this.url({
            id: messageId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Object.<string, *>} params
     * @returns {Promise.<InternalMessage>}
     */
    checkMessage(params) {

        const url = this.url() + '/check-message';

        return this.http.get(url, {
            headers: this.authHeaders,
            params
        })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {InternalMessage} message
     * @returns {Promise.<boolean>}
     */
    delete(message) {

        const url = this.url({
            id: message.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/internal-message.service.js